module.exports = __webpack_public_path__ + "static/full-width-image-dark-9f9ea4665587c672604f308cf3daa129.jpg";